var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlcohol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9712 2.25003C7.52431 2.24732 7.09226 2.41024 6.75843 2.70735C6.4246 3.00446 6.21266 3.41469 6.16351 3.85888C5.96466 5.77503 5.8562 8.66733 5.8562 9.48079C5.8562 14.2169 9.47158 16.7116 13.9908 16.7116C18.51 16.7116 22.1254 14.2169 22.1254 9.48079C22.1254 8.66733 22.0169 5.86541 21.8181 3.85888C21.769 3.41469 21.557 3.00446 21.2232 2.70735C20.8893 2.41024 20.4573 2.24732 20.0104 2.25003H7.9712Z",
    stroke: "#4F84E8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9908 16.7109V25.7494",
    stroke: "#4F84E8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3755 25.75H17.6062",
    stroke: "#4F84E8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlcohol);
export default __webpack_public_path__ + "static/media/alcohol.2155b764c29ddb3befb6a7b6be703f76.svg";
export { ForwardRef as ReactComponent };